import { render, staticRenderFns } from "./startimpression.vue?vue&type=template&id=6d3256d6&scoped=true&lang=html&"
import script from "./startimpression.vue?vue&type=script&lang=js&"
export * from "./startimpression.vue?vue&type=script&lang=js&"
import style0 from "./startimpression.vue?vue&type=style&index=0&id=6d3256d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3256d6",
  null
  
)

export default component.exports